require('./Scripts/controllerBase')

// require('./Scripts/global')
require('./Scripts/paginator.ts')
require('./Scripts/objectBase.js')
require('./Scripts/breadcrumb.ts')
require('./Scripts/dataBreadcrumb.js')
require('./Scripts/asideDireita.js')
require('./Scripts/asideEsquerda.js')
require('./Scripts/readOnlyController.js')
require('./Scripts/gridController.ts')

require('./Scripts/labelProdutoComponent.js')
require('./Scripts/seguranca.js')
require('./Scripts/fixarGridItens.js')
require('./Scripts/renovaSessaoAplicativo.js')
require('./Content/tailwind-dist.css')
require('./Content/material-icons.css')
require('./Content/material-symbols.css')

// a ordem do layout.css e select2.min.css eh importante, se inverter os selects no grid de itens ficam desconfigurados
require('./Content/layout.css')
require('./assets/select2/css/select2.min.css')
require('./Content/estilo.css')
// select.css depende das regras de select de estilo.css (altura/borda/padding),
// entao precisa vir DEPOIS dele para trocar a seta nativa pela nossa.
require('./Content/select.css')
// Por ultimo: tema.css define as variaveis --mu-* do tema escuro e sobrescreve
// utilitarias do Tailwind e CSS de terceiros (MUI, select2, jQuery UI, Bootstrap).
require('./Content/tema.css')



const store = require('./Scripts/app/redux/store/store').default

window.store = store
window.ReactDOM = require('react-dom')
window.React = require('react')
window.ItensOrcamentoContainer = require('./Scripts/app/components/itens-orcamento/ItensOrcamentoContainer').ItensOrcamentoContainer
window.PaginaPesquisaProdutoContainer = require('./Scripts/app/components/pesquisa-produtos/PaginaPesquisaProdutoContainer').PaginaPesquisaProdutoContainer
window.getComponentWithStore = require('./Scripts/app/components/getComponentWithStore').getComponentWithStore
// As views .cshtml sao servidas como JS puro (sem bundler) e nao podem importar
// modulos — o botao de tema do header (Views/Comum/_Menu.cshtml) usa window.temaMU.
window.temaMU = require('./Scripts/app/tema').temaMU

function requireAll(r) { r.keys().forEach(r); }
// Tres exclusoes, todas por peso de bundle:
// - "*.stories.*" e as pastas "stories/": alem das stories, os fixtures em
//   grid-itens/stories/dados-teste importam `action` de storybook/actions. No Storybook 6 isso
//   custava pouco; o barril do Storybook 9 arrasta preview-api + instrumenter + test (1,4MB)
//   para dentro do main. Import explicito continua funcionando - o que sai e so a varredura.
// modalLeitorCodigoBarras (zxing + tesseract, ~1,3MB) fica de fora dessa varredura de proposito:
// ele so deve entrar no bundle via import() sob demanda (lazy) quando o modal e aberto - ver
// PesquisaProdutos.tsx/FinalizarOrcamento.tsx. Se essa pasta continuar aqui, o require.context
// cria uma referencia sincrona para o modulo e o webpack nunca consegue separar em chunk proprio,
// mesmo com React.lazy/import() no ponto de uso.
requireAll(require.context('./Scripts/app/', true, /^(?!.*\.stories\.)(?!.*\/stories\/)(?!.*\/modalLeitorCodigoBarras\/).*\.(js|tsx?)$/));

window.criarOrcamentoUseCase = require('./Scripts/app/use-cases/orcamento/criarOrcamento').criarOrcamento

require('signalr')

require('./Scripts/app/controleSessoesAplicativoAbertasViaWebsockets.ts')


$(document).ready(function () {
    if (window.location.pathname != "/Login") {
        labelProdutoComponent.iniciar();
        setTimeout($.proxy(labelProdutoComponent.aplicar, labelProdutoComponent), 50);
    }

    (function ($) {

        var htmlCallback = $.fn.html;
        var showCallback = $.fn.show;
        var applyBindingsCallback = ko.applyBindings;

        $.fn.html = function () {
            var result = htmlCallback.apply(this, arguments);
            labelProdutoComponent.aplicar(this);
            return result;
        };

        $.fn.show = function () {
            var result = showCallback.apply(this, arguments);
            labelProdutoComponent.aplicar(this);
            return result;
        };

        ko.applyBindings = function () {
            var result = applyBindingsCallback.apply(this, arguments);
            if (arguments && arguments.length > 1) {
                labelProdutoComponent.aplicar(arguments[1]);
            }
            return result;
        };

    }(jQuery));



    global.applyMasks()
    global.addValidators()

    window.enovo = () => store.getState().orcamento

    window.eantigo = () => orcamentoController.model.toJSON()

    window.dumpOrcamento = require('./Scripts/app/use-cases/orcamento/dumpOrcamento').dumpOrcamento

    // Atribui o componente de Telemetria globalmente
    const PopupTelemetria = require('./Scripts/app/components/telemetria/telemetria_popup').default

    window.PopupTelemetria = PopupTelemetria

    // Renderizar o popup de configuração da telemetria no root da aplicação
    const telemetriaContainer = document.createElement('div')
    telemetriaContainer.id = 'popup-telemetria-root'
    document.body.appendChild(telemetriaContainer)

    // React 18: `ReactDOM.render` saiu em favor de `createRoot`. Este popup e montado uma unica
    // vez, no load da pagina, e nunca desmontado — nao precisa entrar no registro de raizes da
    // ponte (renderizarOuRemoverComponentReact), e por isso usa createRoot direto. Passar pela
    // ponte tambem embrulharia o componente num ThemeProvider que ele nao tinha antes.
    require('react-dom/client').createRoot(telemetriaContainer).render(
        window.React.createElement(PopupTelemetria)
    )

});